import { render, staticRenderFns } from "./editGroup.vue?vue&type=template&id=f3459be0&scoped=true&lang=pug"
import script from "./editGroup.vue?vue&type=script&lang=js"
export * from "./editGroup.vue?vue&type=script&lang=js"
import style0 from "./editGroup.vue?vue&type=style&index=0&id=f3459be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_82f4f5227389e3f7a8a9ca9213a48706/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3459be0",
  null
  
)

export default component.exports